<script setup>
import {computed, onBeforeMount, ref, watch} from 'vue'
import {useModalsStore} from '@/stores/modals'
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String,
    currentData: Object,
    field: Object,
})

// Pinia Stores
const modalsStore = useModalsStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Local state initialized from currentData
const value = ref(props.currentData[props.field.name])

// Computed
const tableName = computed(() => {
    return formStore.value?.tableName
})

// Watcher to sync local ref back to currentData object
watch(value, (newValue) => {
    props.currentData[props.field.name] = newValue === '1' ? 1 : 0
})

// Lifecycle: Set default value if required before mounting
onBeforeMount(() => {
    formStore.value?.setDefaultValue({
        name: props.field.name,
        value: props.field.checked || 0
    })
})

// Logic-heavy click handler
const onClick = (e) => {
    const sensitiveFields = [
        'showMetadata',
        'showTags',
        'showScripts',
        'useArchive',
        'showDisplayOrder',
        'showScheduling',
        'showStatus'
    ]

    if (
        tableName.value === 'modulecomponents' &&
        sensitiveFields.includes(props.field.name) &&
        parseInt(props.currentData[props.field.name])
    ) {
        modalsStore.show({
            componentName: 'ConfirmModal',
            obj: {
                modalTitle: 'Are you sure?',
                modalBody: `
                    <p class="alert alert-danger">
                        This action will result in loss of data.
                    </p>
                    <p>
                        This action <strong>cannot</strong> be undone.
                    </p>
                `,
                onConfirm: () => {
                    value.value = 0
                }
            }
        })

        e.preventDefault()
    }
}
</script>

<template>
    <input
        v-if="field.readonly"
        v-model="value"
        disabled
        false-value="0"
        true-value="1"
        type="checkbox"
        class="form-check-input"
    >
    <input
        v-else
        :id="field.id"
        v-model="value"
        :disabled="field.disabled"
        :name="field.name"
        :required="field.required"
        false-value="0"
        true-value="1"
        type="checkbox"
        @click="onClick"
        class="form-check-input"
    >
</template>